import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";
import styles from "./EcommerceConsultancySummaryHeaderInfo.module.scss";

type EcommerceConsultancySummaryHeaderInfoProps = {
  personName: string;
  currentRol: string;
  product?: ProductInfo;
};

export default function EcommerceConsultancySummaryHeaderInfo({
  personName,
  currentRol,
  product,
}: EcommerceConsultancySummaryHeaderInfoProps) {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  const hasProduct = product && Object.keys(product).length > 0;

  return (
    <div className={styles.headerContainer}>
      <button className={styles.buttonGoBack} onClick={handleGoBack}>
        <ArrowBackIosIcon />
      </button>

      {hasProduct && product.image && (
        <img
          src={product.image}
          alt={`Imagen del producto ${product.name}`}
          className={styles.productImage}
        />
      )}

      <div className={styles.infoContainer}>
        <h2 className="subtitle-2">
          {currentRol}:{" "}
          <span className="body-1 text-capitalize">{personName}</span>
        </h2>

        {hasProduct && (
          <h2 className="subtitle-2">
            Producto:{" "}
            <span className="body-1 text-capitalize">{product.name}</span>
          </h2>
        )}
      </div>
    </div>
  );
}
